import React from 'react';
import TableFluidLarge from '../../../common/TableFluidLarge';
const headers = [
  {
    id: 1,
    col: 2,
    desc: `During the plan implementation phase`,
  },
  {
    id: 2,
    col: 2,
    desc: `Ongoing support (once the plan is implemented)`,
  },
];

const tableRows = [
  {
    id: 1,
    header: 'Email',
    rowDesc: [
      {
        id: 1,
        desc: `<a href="mailto:newplan@myubiquity.com">newplan@myubiquity.com.</a>`,
      },
      {
        id: 2,
        desc: `<a href="mailto:tpasupport@myubiquity.com">tpasupport@myubiquity.com.</a>`,
      },
    ],
  },
  {
    id: 2,
    header: 'Phone',
    rowDesc: [
      { id: 1, desc: `855-910-4015` },
      { id: 2, desc: ` 855-472-0472` },
    ],
  },
  {
    id: 3,
    header: 'Hours',
    rowDesc: [
      { id: 1, desc: `Mon.–Fri., 8 a.m.– 4 p.m. PT` },
      { id: 2, desc: `Mon.–Fri., 6 a.m.–5 p.m. PT` },
    ],
  },
];
const SupportTableSection = () => (
  <section id="notices-table" className="table-section section_py-5 pt-0">
    <div className="container-lg bg-white">
      <div className="row">
        <div className="col-lg-10 mx-auto px-md-3 px-0">
          <strong>Day-to-day contact with Ubiquity</strong>
          <br></br>
          You can reach Ubiquity by telephone or email. Additionally, Help
          Center FAQs will be available.
          <TableFluidLarge tableHeaders={headers} tableRows={tableRows} />
        </div>
      </div>
    </div>
  </section>
);

SupportTableSection.propTypes = {};

export default SupportTableSection;
